import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import CodeInfoSection from 'components/CodeInfoSection';
import { Divider, Typography } from 'material-ui';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoClassificationComments extends Component {

    render() {
        const { model, onDate } = this.props;
        const title = ((new Date('2022-02-10 00:00:00')) <= onDate) ? 'Разъяснений о классификации в соответствии с единой ТНВЭД ЕАЭС отдельных видов товаров. Приложение к приказу ФТС от 17.11.2021 г. N 995' :
        'Разъяснения о классификации в соответствии с ТН ВЭД ЕАЭС отдельных товаров. Приложение к приказу ФТС России от 14 января 2019 г. № 28 (опубликован 16.04.2019 г., вступает в силу 17.05.2019 г. действует по 09.02.2022 г)'
        return (
            <CodeInfoSection title={title}
                expanded={false} 
                action={'classification_comments'} 
                count={model.classification_comments.length}>
                <div>
                    {model.classification_comments.map((comment, index) => (
                        <div key={index} >
                            <Typography component='div' paragraph >
                                <div dangerouslySetInnerHTML={{ __html: comment }}></div>
                            </Typography>
                            {index < model.classification_comments.length - 1 &&
                                <Typography component='div' paragraph >
                                    <Divider />
                                </Typography>
                            }
                        </div>
                    ))}
                </div>
            </CodeInfoSection>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoClassificationComments.js